<template>
  <div class="ls-input-label">
    <div class="ls-input-label--top">
      <div
        class="ls-input-label--labels"
        :class="{ 'ls-input-label--one-line-label': oneLineLabel }"
      >
        <p test-id="label" class="ls-input-label--label">{{ label }}</p>
        <p test-id="sub_label" class="ls-input-label--sub-label">{{ subLabel }}</p>
      </div>
      <div
        v-if="collapseContent"
        test-id="question_mark"
        class="ls-input-label--question-mark"
        @click="onClick"
      >
        ?
      </div>
    </div>
    <BCollapse v-if="collapseContent" :open.sync="open" test-id="collapse">
      <div class="ls-input-label--collapse-content">{{ collapseContent }}</div>
    </BCollapse>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'LsInputLabel',
  props: {
    label: VueTypes.string,
    subLabel: VueTypes.string,
    oneLineLabel: VueTypes.bool.def(false),
    collapseContent: VueTypes.string,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    onClick() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-input-label {
  padding: 10px 0;
}

.ls-input-label--label {
  font-weight: bold;
}

.ls-input-label--one-line-label {
  display: flex;
  :first-child {
    margin-right: 5px;
  }
}

.ls-input-label--top {
  display: flex;
  justify-content: space-between;
}

.ls-input-label--question-mark {
  user-select: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: $white;
  font-weight: bold;
  font-size: $size-6;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: $blue;
  margin-left: 10px;
}

.ls-input-label--collapse-content {
  margin-top: 6px;
  font-size: $size-6;
  font-style: italic;
  background-color: $primary-light;
  padding: 20px;
}

.themed-app {
  .ls-input-label--question-mark {
    background-color: $theme-color-info;
    color: $theme-color-white;
  }

  .ls-input-label--collapse-content {
    background-color: $theme-color-primary-light;
  }
}
</style>
